var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-admin"},[_c('Sidenav'),_c('router-view',{key:_vm.$route.path,staticClass:"page-admin__content-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }